import { RootState } from '../reducers';
import { AppConfig } from 'types/config';

export const root = (state: RootState) => state.config as AppConfig;

export const featureFlagsSelector = (state: RootState) => root(state).featureFlags || {};
